<script>
  import Checkbox from '../elements/Checkbox.svelte';
  import Collapse from '../elements/Collapse.svelte';
  import classNames from 'classnames';

  export let title = '';
  export let text = '';
  export let customClass = '';
  export let id = null;
  export let checked = true;

  const purposeClass = classNames('scmp_Purpose', customClass);
</script>

<div class={purposeClass}>
  <div class="scmp_Purpose-checkbox">
    <Checkbox on:change value={id} {checked} {id} />
  </div>
  <div class="scmp_Purpose-content">
    <div class="scmp_Purpose-content-title">{title}</div>
    <p class="scmp_Paragraph">
      {@html text}
    </p>
    <Collapse>
      <slot />
    </Collapse>
  </div>
</div>
